/**
 * Helpers puros para níveis de gamificação.
 * Extraído de GamificationWidgets para permitir testes sem dependência de UI.
 */

export const LEVEL_THRESHOLDS = [0, 100, 300, 600, 1000, 1500, 2200, 3000, 4000, 5000];
export const LEVEL_NAMES = [
  'Iniciante',
  'Estudante',
  'Dedicado',
  'Esforçado',
  'Aplicado',
  'Avançado',
  'Expert',
  'Mestre',
  'Grande Mestre',
  'Lenda',
] as const;

export interface LevelInfo {
  level: number;
  name: string;
  currentThreshold: number;
  nextThreshold: number;
  pointsToNext: number;
  progressPercent: number;
}

export function getLevelInfo(currentLevel: number, totalPoints: number): LevelInfo {
  const level = Math.min(Math.max(currentLevel, 1), LEVEL_NAMES.length);
  const name = LEVEL_NAMES[level - 1] || 'Iniciante';
  const currentThreshold = LEVEL_THRESHOLDS[level - 1] ?? 0;
  const nextThreshold = LEVEL_THRESHOLDS[level] ?? currentThreshold + 1000;
  const denom = Math.max(nextThreshold - currentThreshold, 1);
  const progressPercent = Math.min(
    Math.max(((totalPoints - currentThreshold) / denom) * 100, 0),
    100,
  );
  return {
    level,
    name,
    currentThreshold,
    nextThreshold,
    pointsToNext: Math.max(nextThreshold - totalPoints, 0),
    progressPercent,
  };
}
